import { FulfillmentGroupColumnKey } from "@redotech/redo-fulfillment-common/fulfillment-group-column-keys";
import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTablePaddedCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { MoneyText } from "@redotech/redo-web/fx/money-text";
import { toMoney } from "@redotech/redo-web/fx/to-money";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { Text } from "@redotech/redo-web/text";

const catalogEntry = fgColumnEntries[FulfillmentGroupColumnKey.TAX_TOTAL];

export const TaxTotalColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  alignment: ColumnAlignment.LEFT,
  renderNormalCell: ({ row }) => (
    <RedoTablePaddedCell>
      <Text as="span" fontSize="xs" fontWeight="regular" textColor="secondary">
        <MoneyText
          struck
          value={toMoney({
            amount: Number(row.totalTax.amount),
            currency: row.totalTax.currency,
          })}
        />
      </Text>
    </RedoTablePaddedCell>
  ),
  width: catalogEntry.defaultWidth,
  sort: catalogEntry.sortDirection,
};
